 
import _ from 'underscore'

import CONSTANT from '../constant/rc'

export default {
  enableAppTip ({ commit }) {
    commit(CONSTANT.RC_APPTIP_SET_ENABLE)
  },
  disableAppTip ({ commit }) {
    commit(CONSTANT.RC_APPTIP_SET_DISABLE)
  },
  setAppSourceData ({ commit } , data) {
    commit(CONSTANT.RC_APPTIP_SET_APPSRC, data)
  },
  setAppSource ({ commit }, src) {
    commit(CONSTANT.RC_APPTIP_SET_APPACTION, src)
  }
}
